import { ActionReducerMap } from '@ngrx/store';
import * as fromProfile from './reducers/profile.reducer';
import * as fromUser from './reducers/user.reducer';
import { ProfileState } from './state/profile.state';
import { UserState } from './state/user.state';
import * as ReviewEntriesReducer from '@pages/review-entries/store/reducers/review-entries.reducer';
import { ReviewEntriesState } from '@pages/review-entries/store/state/review-entries.state';
import { HomeState } from '@app/pages/home/store/state/home.state';
import * as HomeReducer from '@app/pages/home/store/reducers/home.reducer';
import { RolePermissionState } from './role-permission/state/role-permission.state';
import { rolePermissionReducer } from './role-permission/reducers/role-permission.reducer';

export interface AppState {
  profile: ProfileState;
  user: UserState;
  reviewEntries: ReviewEntriesState;
  home: HomeState;
  rolePermission: RolePermissionState;
}

export const reducers: ActionReducerMap<AppState> = {
  profile: fromProfile.profileReducer,
  user: fromUser.userReducer,
  reviewEntries: ReviewEntriesReducer.reviewEntriesReducer,
  home: HomeReducer.homeReducer,
  rolePermission: rolePermissionReducer,
};